import React from 'react'
import Eula from '../eula'

const EulaFr = () => {
    return <Eula languageCode="fr" />
}

export default EulaFr
